import React from 'react';

const AdminProductModeration = () => (
  <div style={{ padding:'1rem' }}>
    <h1 style={{ marginTop:0 }}>Product Moderation</h1>
    <p>Admin tools for reviewing, hiding/unhiding, and auditing products will appear here.</p>
  </div>
);

export default AdminProductModeration;
